import { render, staticRenderFns } from "./EditShape.vue?vue&type=template&id=3e52e1c8&scoped=true&"
import script from "./EditShape.vue?vue&type=script&lang=js&"
export * from "./EditShape.vue?vue&type=script&lang=js&"
import style0 from "./EditShape.vue?vue&type=style&index=0&id=3e52e1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52e1c8",
  null
  
)

export default component.exports